import { Button, Modal } from "antd";
import "./styles.scss";
import React, { useEffect, useState } from "react";
import url from "../../url.json";
import axios from "axios";
import { withTranslation, useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import headers from "../../config/headers";
import { useSelector, useDispatch } from "react-redux";

import {
  RetweetOutlined,
  FileWordOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  FileJpgOutlined,
} from "@ant-design/icons";
import { modalpayReducer } from "../../Redux/Reducers/Modal/modalpay";
import { modalpaydelReducer } from "../../Redux/Reducers/Modal/modalpaydel";
function ModalPayDel(props) {
  const show = useSelector((state) => state.modaldoc);

  const [file, setFile] = useState();
  const [title, setTitle] = useState();
  const [names, setName] = useState();
  const [visible, setVisible] = useState(false);
  const [icon, setIcon] = useState();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleOk = () => {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
    axios
      .delete(url.url + `/payment/${props.res.id}`, {
        headers: headers(),
      })
      .then((res) => {
        if (res.status == 200) {
          dispatch(modalpaydelReducer(props.res.id));

          toast.success(t("Success!"));
          props.handleCancel();
        }
      })
      .catch((err) => {
        if (err.response.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        if (err.response.status == 404) window.location = "/404";
        if (err.response.status == 405) toast.error(err.response.data.error);
        toast.error(err.response.data.error);
      });
  };

  return (
    <>
      <Modal
        title={t("Do you want to delete?")}
        visible={props.show}
        onOk={handleOk}
        okText={t("Delete")}
        cancelText={t("Cancel")}
        onCancel={() => props.handleCancel()}
      >
        <div className="mod-container">
          <div className="mod-inner-holder">
            <div className="mod-icon">{icon}</div>
            <span className="mod-file-name">
              {
                props.res?.file?.split("/")[
                  props.res?.file?.split("/")?.length - 1
                ]
              }
            </span>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default withTranslation()(ModalPayDel);
